var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6512_4510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0427 0.211142L9.20258 11.7887H6.04139L3.65996 2.54778C3.63879 2.33286 3.56314 2.12694 3.44019 1.94956C3.31724 1.77218 3.15108 1.62923 2.95747 1.5343C2.01757 1.08098 1.02369 0.749854 0 0.548968L0.0702487 0.211142H5.15626C5.49025 0.21405 5.81229 0.336078 6.06462 0.555341C6.31694 0.774604 6.48304 1.07676 6.53313 1.40761L7.79058 8.10784L10.9026 0.211142H14.0427ZM26.4205 8.00931C26.4205 4.95479 22.2056 4.78588 22.2056 3.42049C22.2056 3.00525 22.6131 2.56185 23.4771 2.44924C24.4872 2.35347 25.5043 2.53344 26.4205 2.97006L26.9755 0.513778C26.077 0.175935 25.1253 0.00193218 24.1656 0C21.2081 0 19.1287 1.57652 19.1147 3.8287C19.1147 5.48968 20.5969 6.42574 21.7279 6.97471C22.8589 7.52368 23.2875 7.91077 23.2804 8.41751C23.2804 9.1917 22.3531 9.53656 21.4961 9.55064C20.4276 9.58041 19.369 9.33826 18.4192 8.84683L17.8783 11.3805C18.9393 11.7956 20.0691 12.0057 21.2081 11.9999C24.3412 11.9999 26.3995 10.4445 26.4065 8.03746L26.4205 8.00931ZM34.2392 11.7887H37L34.5764 0.211142H32.0264C31.7488 0.20264 31.4753 0.279758 31.2428 0.432067C31.0104 0.584376 30.8303 0.804527 30.7268 1.06275L26.266 11.7887H29.4061L30.0243 10.0574H33.8529L34.2392 11.7887ZM30.9024 7.68555L32.476 3.33604L33.3822 7.68555H30.9024ZM18.3138 0.211142L15.8411 11.7887H12.8555L15.3212 0.211142H18.3138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6512_4510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/VisaLogo.25fd205e70c227c649acd113be039d5b.svg";
export { ForwardRef as ReactComponent };